import { Box, TableCell, TableRow, Typography } from '@mui/material'
import { ITrialMembership } from '../interface'
import { FormattedMessage } from 'react-intl'

const TrialMembership = (props: ITrialMembership) => {
  return (
    <TableRow>
      <TableCell width={60} sx={{ pl: 3 }}>
        <Box component='img' src={props.icon} alt={`${props.category} icon`} sx={{ width: 24, display: 'flex' }} />
      </TableCell>
      <TableCell>
        <FormattedMessage
          id={`trialMembership.${props.category}.description`}
          values={{ membership: props.version, noChargeMonths: props.noChargeMonths }}
        />
        <Box pt={1}>
          {props.includedBy.map((item: string, index: number) => (
            <Typography fontSize={12} key={`${item}-${index}`}>
              <FormattedMessage id='trialMembership.includedBy' values={{ includedBy: item }} />
            </Typography>
          ))}
        </Box>
      </TableCell>
      <TableCell colSpan={3}>x{props.quantity}</TableCell>
    </TableRow>
  )
}

export default TrialMembership
